<template>
	<input-form action="/json/contact" @submit="form = {}; $refs.captcha.reset();" @loading="$emit('loading', $event)" :unsaveable="true" v-slot="props" :object-data="form">
		<loader :loading="props.loading > 0"></loader>
		<div class="row">
			<div class="col-24 col-md-12">
				<input-text v-model="props.object.name" label="Name" :errors="props.errors.name"></input-text>
			</div>
			<div class="col-24 col-md-12">
				<input-text v-model="props.object.email" label="Email" inputmode="email" :errors="props.errors.email"></input-text>
			</div>
		</div>
		<input-textarea v-model="props.object.message" label="Message" :errors="props.errors.message"></input-textarea>
		<div class="captcha-button">
			<input-captcha ref="captcha" v-model="props.object.contact" name="contact" label="Captcha" :errors="props.errors.contact"></input-captcha>
			<icon-button type="submit" :disabled="props.loading > 0" icon="arrows/send/output-right">Send</icon-button>
		</div>
	</input-form>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					contact: null
				}
			};
		}
	}
</script>